PluginButtonsView = require 'app/scripts/views/plugin/plugin-buttons-view'
PluginHeaderButtonView = require 'app/scripts/views/plugin/plugin-header-button-view'

module.exports = class PluginHeaderButtonsView extends PluginButtonsView
  tagName: 'span'
  className: 'board-header-plugin-btns'
  buttonView: PluginHeaderButtonView
  runnerOptions: ->
    command: 'board-buttons'
    timeout: 10000
    board: @model
